import { render, staticRenderFns } from "./clothBox.vue?vue&type=template&id=cbc3baaa&scoped=true&"
import script from "./clothBox.vue?vue&type=script&lang=js&"
export * from "./clothBox.vue?vue&type=script&lang=js&"
import style0 from "./clothBox.vue?vue&type=style&index=0&id=cbc3baaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc3baaa",
  null
  
)

export default component.exports